import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Typography } from 'antd'

const version = process.env.REACT_APP_VERSION
const Text = Typography.Text

export const Version = ({ color }) =>
  version ? (
    <Footer>
      <Text disabled style={{ color: color }}>{`Version ${version}`}</Text>
    </Footer>
  ) : (
    <div />
  )

Version.propTypes = {
  color: PropTypes.string
}

Version.defaultProp = {
  color: ''
}

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 15px;
  width: 100%;
`

export default Version
